import { render, staticRenderFns } from "./update-show.vue?vue&type=template&id=e6b1b836&"
import script from "./update-show.vue?vue&type=script&lang=js&"
export * from "./update-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports